module.exports = __webpack_public_path__ + "img/features_pic05.8fb94c67.png";